import {Button, Modal, Typography} from "@mui/material";
import {useTranslation} from "react-i18next";
import AppModalBox from "./AppModalBox";

interface Props {
    open: boolean;
    onClose: () => void;
    onConfirm: () => void;
}

const DeleteConfirmationModal = ({open, onClose, onConfirm}: Props) => {
    const {t} = useTranslation();

    return (
        <Modal open={open} onClose={onClose}>
            <AppModalBox
                sx={{
                    textAlign: "center"
                }}
            >
                <Typography variant="h6">
                    {t("common.deleteConfirmation")}
                </Typography>

                <Button
                    variant="contained"
                    color="error"
                    onClick={onConfirm}
                    sx={{mt: 2, mr: 2}}
                >
                    {t("common.delete")}
                </Button>

                <Button variant="outlined" onClick={onClose} sx={{mt: 2}}>
                    {t("common.cancel")}
                </Button>
            </AppModalBox>
        </Modal>
    );
};

export default DeleteConfirmationModal;